import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

const NotVerified = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.33 3.032a.82.82 0 0 0-.453 0L4.583 5.134A.801.801 0 0 0 4 5.902v4.31c0 4.876 3.16 9.206 7.845 10.747a.82.82 0 0 0 .512 0c4.684-1.541 7.843-5.87 7.843-10.746v-4.31a.801.801 0 0 0-.583-.769l-7.286-2.102ZM8.71 8.611a.72.72 0 0 1 1.02 0l2.37 2.37 2.37-2.37a.72.72 0 0 1 1.02 1.018L13.117 12l2.371 2.37a.72.72 0 1 1-1.018 1.02L12.1 13.017 9.73 15.39a.72.72 0 1 1-1.02-1.018L11.083 12 8.71 9.63a.72.72 0 0 1 0-1.02Z"
    />
  </Icon>
);

export default NotVerified;
